module.exports = __webpack_public_path__ + "static/media/especial3.9fee3add.png";